import { bootstrapApplication } from '@angular/platform-browser';
import { register as registerSwiper } from 'swiper/element/bundle';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Register Swiper's <swiper-container>/<swiper-slide> custom elements once for the whole app.
registerSwiper();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
